import { useEffect, useState } from "react";
import { AppForm, AppFormFastField, AppFormMobileField, AppFormRadioField, AppFormTextArea, AppSubmitButton } from "../../../../AppComponents/Forms"
import { Box } from "@mui/material";
import AppButton from "../../../../AppComponents/AppButton";
import { useAppDispatch, useAppSelector } from "../../../../Store";
import AppFormCustomRadioField from "../../../../AppComponents/Forms/AppFormCustomRadioField";
import { LinkText } from "../../../../Customization/CommonElements";
import { theme } from "../../../../Customization/Theme";
import { whatsappDataStore } from "../../../../Store/Slices/Whatsapp/whatsapp.selectors";
import { WhatsappSettingsActions } from "../../../../Store/Slices/Settings/WhatsappSettings/whatsappSettings.actions";
import { WhatsappSettingsWrapper } from "../../Email/Styles";
import { whatsappConfigList } from "../../../../Store/Slices/Settings/WhatsappSettings/whatsappSettings.selectors";
import { Link } from "react-router-dom";
import { useNotification } from "../../../../Hooks/useNotification/useNotification";
import { WhatsAppConfigValidations } from "../../../../Models/ValidationSchema";

const WhatsAppForm = (props: any) => {
    const dispatch = useAppDispatch();
    const { showAlert } = useNotification();
    const configData = useAppSelector(whatsappConfigList)
    const [isFilled, setIsFilled] = useState<boolean>(false);
    const [userInput, setUserInput] = useState<any>({
        email: "",
        customer_company_name: "",
        company_registred_address: "",
        company_website: "",
        company_facebook_business_manage_ID: "",
        display_name: "",
        display_number: "",
        is_business_verified_on_facebook: "",
        migrating_from_other_whatsapp_api_provider: "",
        is_two_factor_authentication_removed_from_other_vendor: "",
    });

    useEffect(() => {
        if (!configData) {
            dispatch(WhatsappSettingsActions.whatsappConfigList({}));
        } else if (configData?.config_value?.email) {
            setIsFilled(true);
            setUserInput({
                email: configData?.config_value?.email,
                customer_company_name: configData?.config_value?.customer_company_name,
                company_registred_address: configData?.config_value?.company_registred_address,
                company_website: configData?.config_value?.company_website,
                company_facebook_business_manage_ID: configData?.config_value?.company_facebook_business_manage_ID,
                display_name: configData?.config_value?.display_name,
                display_number: configData?.config_value?.display_number,
                is_business_verified_on_facebook: configData?.config_value?.is_business_verified_on_facebook,
                migrating_from_other_whatsapp_api_provider: configData?.config_value?.migrating_from_other_whatsapp_api_provider,
                is_two_factor_authentication_removed_from_other_vendor: configData?.config_value?.is_two_factor_authentication_removed_from_other_vendor,
            })
        }
    }, [configData])

    // HandleSubmit
    const handleSubmit = (values: any, submittingProps: any) => {
        let payload = { ...values }
        dispatch(WhatsappSettingsActions.whatsappConfigData(payload)).then(() => {
            dispatch(WhatsappSettingsActions.whatsappConfigList({}));
            showAlert("Config Added Successfully", "success");
        }).catch((error: any) => {
            showAlert(error?.error || "Something went wrong", "error");
        })
        submittingProps.setSubmitting(false);



    }

    return (
        <WhatsappSettingsWrapper>
            <AppForm
                initialValues={userInput}
                onSubmit={handleSubmit}
                validationSchema={WhatsAppConfigValidations}

            >
                <div className="d-flex">
                    <Box>
                        <label>Email</label>
                        <Box className="d-flex">
                            <AppFormFastField
                                name="email"
                                placeholder="Enter your email address"
                                disabled={isFilled}
                            />

                        </Box>
                    </Box>
                    <Box>
                        <label>Customer company name</label>
                        <Box className="d-flex">
                            <AppFormFastField
                                name="customer_company_name"
                                placeholder="Company name"
                                disabled={isFilled}
                            />

                        </Box>
                    </Box>
                    <Box>
                        <label>Company Registred Address</label>
                        <Box className="d-flex">
                            <AppFormFastField
                                name="company_registred_address"
                                placeholder="Registerd address"
                                disabled={isFilled}
                            />

                        </Box>
                    </Box>
                </div>

                <div className="d-flex">
                    <Box>
                        <label>Company Website</label>
                        <Box className="d-flex">
                            <AppFormFastField
                                name="company_website"
                                placeholder="Company website"
                                disabled={isFilled}
                            />

                        </Box>
                    </Box>
                    <Box>
                        <label>Company Facebook Business ID*</label>
                        <Box className="d-flex">
                            <AppFormFastField
                                name="company_facebook_business_manage_ID"
                                placeholder="Facebook business manage ID"
                                disabled={isFilled}
                            />

                        </Box>
                    </Box>
                    <Box>
                        <label>Display Name *</label>
                        <Box className="d-flex">
                            <AppFormFastField
                                name="display_name"
                                placeholder="Display name"
                                disabled={isFilled}
                            />

                        </Box>
                    </Box>
                </div>
                <div>
                    <AppFormCustomRadioField
                        label="Is Business Verified on Facebook *"
                        name="is_business_verified_on_facebook"
                        Options={[{ value: "yes", label: "Yes" }, { value: "no", label: "no" }, { value: "maybe", label: "maybe" }]}
                        disabled={isFilled}
                    >

                    </AppFormCustomRadioField>
                </div>
                <div>
                    <AppFormCustomRadioField
                        label="Are you migrating from other Whatsapp API's provider"
                        name="migrating_from_other_whatsapp_api_provider"
                        disabled={isFilled}
                        Options={[{ value: "yes", label: "Yes" }, { value: "no", label: "no" }, { value: "maybe", label: "maybe" }]}>

                    </AppFormCustomRadioField>
                </div>
                <div>
                    <AppFormCustomRadioField
                        label="Is 2 Factor Authentication removed from other vendor*"
                        name="is_two_factor_authentication_removed_from_other_vendor"
                        disabled={isFilled}
                        Options={[{ value: "yes", label: "Yes" }, { value: "no", label: "no" }, { value: "maybe", label: "maybe" }]}>

                    </AppFormCustomRadioField>
                </div>
                <Box className="formFooter">
                    {!isFilled ? <><AppButton variant="grey">
                        Cancel
                    </AppButton>
                        <AppSubmitButton title="Verify" sx={{ marginLeft: "20px" }} /></> : configData?.config_value?.exotel_varification ? <Link to="/broadcast/whatsapp/history/">Go to WhatsApp Broadcasting</Link> : null}
                </Box>

            </AppForm>
        </WhatsappSettingsWrapper>
    )
}
export default WhatsAppForm;